import { TriggerHoldUntilReplyRuleType } from 'modules/workflows/constants/nodes/holdUntilReply';
import {
  CUSTOM_DURATION_VALUE,
  DEFAULT_HOLD_DURATION,
  PRESET_DURATION_MINUTES,
} from './HoldUntilReply.constants';
import { Reply, Variant } from './HoldUntilReply.types';

export const hasAtLeastOneReplyVariant = (replies: Reply[]) =>
  replies?.[0]?.variants?.some((x: Variant) => x.variant !== '');

export const getAlternateTriggerRuleType = (triggerRuleType: TriggerHoldUntilReplyRuleType) =>
  triggerRuleType === TriggerHoldUntilReplyRuleType.SMS
    ? TriggerHoldUntilReplyRuleType.WHATSAPP
    : TriggerHoldUntilReplyRuleType.SMS;

export const parseDuration = ({
  expireDays,
  expireHours,
  expireMinutes,
}: { expireDays: number; expireHours: number; expireMinutes: number }) => {
  const totalMinutes = expireDays * 24 * 60 + expireHours * 60 + expireMinutes;

  if (totalMinutes === 0) {
    return undefined;
  }

  const isCustomDuration = !PRESET_DURATION_MINUTES.includes(totalMinutes);

  return isCustomDuration ? CUSTOM_DURATION_VALUE : totalMinutes;
};

export const createHoldDurationForSave = (
  presetMinutes: number,
  customDuration: { expireDays: number; expireHours: number; expireMinutes: number },
) => {
  if (presetMinutes === 0) return DEFAULT_HOLD_DURATION;

  if (presetMinutes === CUSTOM_DURATION_VALUE) {
    return {
      expireDays: customDuration.expireDays,
      expireHours: customDuration.expireHours,
      expireMinutes: customDuration.expireMinutes,
    };
  }

  if (presetMinutes / 60 < 1) {
    return {
      expireDays: 0,
      expireHours: 0,
      expireMinutes: presetMinutes,
    };
  } else if (presetMinutes / 60 / 24 < 1) {
    return {
      expireDays: 0,
      expireHours: presetMinutes / 60,
      expireMinutes: 0,
    };
  }

  return {
    expireDays: presetMinutes / 60 / 24,
    expireHours: 0,
    expireMinutes: 0,
  };
};
